import React from "react";
import Head from "next/head";
import BreadcrumbScroll from "../../../components/Elements/BreadcrumbScroll/BreadcrumbScroll";
import styles from "../../../styles/LeadershipEnPage.module.css";
import cx from "classnames";
import dynamic from "next/dynamic";

const AccordionComponent = dynamic(
  () =>
    import(
      "../../../components/Elements/AccordionComponent/AccordionComponentEn"
    ),
  {
    ssr: false,
  }
);
const LeadershipEnPage = ({ leaderGroupData: leaderGroupDataJson }) => {
  const leaderGroupData =
    leaderGroupDataJson !== null ? JSON.parse(leaderGroupDataJson) : null;

  return (
    <>
      <Head>
        <title>Leadership - About Digikala Group</title>
        <meta
          name="viewport"
          content="initial-scale=1.0, width=device-width, maximum-scale=1"
        />
        <meta charSet="utf-8" />
        <meta
          name="description"
          content="Digikala was launched in 2006 by Saeed and Hamid Mohammadi twin brothers and has been on constant growth ever since."
        />
        <link rel="icon" type="image/x-icon" href="/faviconNew.svg"></link>
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
        />
        <link
          rel="canonical"
          href={`https://about.digikala.com/en/leadership/`}
        />
        <meta property="og:locale" content="fa_IR" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Leadership - About Digikala Group" />
        <meta
          property="og:url"
          content={`https://about.digikala.com/en/leadership/`}
        />
        <meta property="og:site_name" content="Leadership" />
        <meta property="og:image" content="/ogImage.jpg" />
        <meta property="og:image:width" content="500" />
        <meta property="og:image:height" content="500" />
        <meta
          property="og:image:alt"
          content="Leadership - About Digikala Group"
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:site_name" content="Leadership" key="ogsitename" />
        <meta
          property="og:title"
          content="Leadership - About Digikala Group"
          key="ogtitle"
        />
        <meta
          property="og:description"
          content="Digikala was launched in 2006 by Saeed and Hamid Mohammadi twin brothers and has been on constant growth ever since."
          key="ogdesc"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Leadership - About Digikala Group"
        />
        <meta name="twitter:site" content="About Digikala Group" />
        <meta
          name="twitter:image"
          itemProp="image"
          content="https://about.digikala.com/ogImage.jpg"
        />
        <meta
          name="twitter:description"
          content="Digikala was launched in 2006 by Saeed and Hamid Mohammadi twin brothers and has been on constant growth ever since."
        />
      </Head>
      <BreadcrumbScroll
        title="Leadership"
        routeOne="/en/leadership"
        titleOne="Leadership"
      />
      <div className="breadCrumbSpacer"></div>
      <div className={cx(styles.container)}>
        {leaderGroupData?.results?.length > 0 &&
          leaderGroupData?.results.map((item, index) => (
            <div key={index} className="w-100 mb-2">
              <AccordionComponent
                title={item.title_en}
                leaderList={item.members}
                open={index === 0}
              />
            </div>
          ))}
      </div>
    </>
  );
};

export default LeadershipEnPage;

export async function getServerSideProps(context) {
  try {
    const leaderGroupsRes = await fetch(
      `${
        process.env.ABOUT_API_BASE_URL
      }/api/v1/leadership/groups/en/?reqDate=${Date.now()}`
    );
    const leaderGroupData = await leaderGroupsRes.json();

    return {
      props: {
        leaderGroupData: JSON.stringify(leaderGroupData),
      },
    };
  } catch (error) {
    console.error(error);
    return {
      props: {
        leaderGroupData: null,
      },
    };
  }
}
